import { Box, Stack } from '@mui/material';
import SliderImage from '../../gallery/SliderImage';
import { Mask } from '../../gallery/Masks';
import { Fragment, PropsWithChildren } from 'react';
import imgMapper from '../../../utils/mappers/image';
import { MarkdownImage } from '@jd/platform-config/types';
import { DeepNullToUndefined } from '@jd/client/utils/unnulable';

const BlockImage = ({
  position,
  before: _before,
  after: _after,
  mask,
  fit,
  cssSelector,
  heightMultiplier = 1,
}: DeepNullToUndefined<MarkdownImage>) => {
  const after = imgMapper(_after);
  const before = imgMapper(_before);
  const isSide = position === 'sideLeft' || position === 'sideRight';
  const isFull = position === 'fullWidth';
  const isInset = position === 'inset';
  const standardWidth = isInset ? '100%' : '50%';

  const sizes = isFull
    ? '100vw'
    : isInset
      ? '(max-width: 900px) 100vw, 1200px'
      : '(max-width: 900px) 50vw, 600px';

  const MaskContainer = mask
    ? (props: PropsWithChildren) => <Mask variant={mask!} {...props} />
    : Fragment;
  return (
    <Stack
      className={'tb-image-container'}
      data-selector={cssSelector}
      direction={
        isSide ? (position === 'sideRight' ? 'row-reverse' : 'row') : 'column'
      }
      spacing={2}
      sx={{
        width: {
          xs: isInset ? '100%' : '50%',
          md: standardWidth,
        },
        minHeight: {
          xs: (isInset ? 250 : 200) * heightMultiplier,
          md: 400 * heightMultiplier,
          lg: (isFull ? 500 : 400) * heightMultiplier,
        },
        my: 2,
        float: !isSide ? 'none' : position === 'sideRight' ? 'right' : 'left',
      }}
    >
      <Box
        sx={{
          position: isFull ? 'absolute' : 'relative',
          left: isFull ? { xs: 2, md: 8 } : 0,
          width: {
            xs: isInset ? '100%' : `calc(100% - ${isFull ? 4 : 8}px)`,
            md: isInset ? '100%' : 'calc(100% - 16px)',
          },
          height: {
            xs: (isInset ? 250 : 200) * heightMultiplier,
            md: 400 * heightMultiplier,
            lg: (isFull ? 500 : 400) * heightMultiplier,
          },
        }}
      >
        <MaskContainer>
          <SliderImage
            beforeImage={before}
            afterImage={after}
            sx={{ minHeight: '100%', width: '100%' }}
            sizes={sizes}
            imgStyle={{
              objectFit: fit,
            }}
          />
        </MaskContainer>
      </Box>
    </Stack>
  );
};

export default BlockImage;
